import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import Checkbox from "../components/form/Checkbox";
import Input from "../components/form/Input";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { postData } from "../services/api";
import { authLogin } from "../store/authSlice";
import { Link } from "react-router-dom";
import toastr from "toastr";
import { useTranslation } from "react-i18next";
import { MAIN_LOGO } from "../constant/Constant";
import Image from "../components/elements/Image";

const AdminLogin = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Admin Login"
  );
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLogin, setIsLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLogin(true);
    try {
      const userData = await postData("admin-login", {
        email: email,
        password: password,
      });
      if (userData.status && userData.status === 200) {
        setIsLogin(false);
        dispatch(authLogin(userData.data));
        localStorage.setItem("accessToken", userData?.accessToken);
        localStorage.setItem("role", userData?.data?.code);
        toastr.success(userData.message);
        return navigate("/dashboard-statistics");
      } else {
        toastr.error(userData.message);
        setIsLogin(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsLogin(false);
    }
  };

  return (
    <>
      <div className="font-[sans-serif] bg-white flex items-center justify-center md:h-screen p-4">
        <div className="shadow-[0_2px_16px_-3px_rgba(6,81,237,0.3)] max-w-6xl max-md:max-w-lg rounded-md p-6">
          <Link to={"/"}>
            <div className="h-12 sm:h-16 w-full flex items-start justify-start object-contain mb-5">
              <Image
                src={MAIN_LOGO}
                alt={""}
                width={"100%"}
                height={"100%"}
                classes={"object-contain object-left"}
              />
            </div>
          </Link>

          <div className="grid md:grid-cols-2 items-center gap-8">
            <div className="max-md:order-1 lg:min-w-[450px]">
              <img
                src="/Security-amico.webp"
                className="lg:w-11/12 w-full object-cover"
                alt="login-image"
              />
            </div>

            <form className="w-full mx-auto">
              <div className="mb-9">
                <h4 className="text-4xl font-extrabold text-teal-600">
                  Admin Signin
                </h4>
                <div className="text-sm sm:text-base text-slate-900 font-medium">
                  {t("please_use_your_credentials_to_signin")}
                </div>
              </div>
              <div className="space-y-5">
                <div className="relative z-0 w-full group">
                  <Input
                    inputClasses={
                      "block h-10 !px-0 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                    }
                    inputType={"email"}
                    inputPlaceholder={t("work_email_address")}
                    inputValue={email}
                    setInput={setEmail}
                    functions={onSubmit}
                  />
                </div>

                <div className="relative z-0 w-full group">
                  <Input
                    inputClasses={
                      "block h-10 !pl-0 !pr-8 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                    }
                    inputType={"password"}
                    inputPlaceholder={t("your_password")}
                    inputValue={password}
                    setInput={setPassword}
                    functions={onSubmit}
                    //errorType={''}
                  />
                </div>

                <div className="flex flex-wrap items-center justify-end gap-4 mt-3">
                  <div>
                    <Link
                      to={"/forgot-password"}
                      className="text-teal-500 font-medium text-sm hover:underline"
                    >
                      {t("forgot_password")}
                    </Link>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <Button
                  buttonClasses={
                    "!w-full !shadow-xl !py-2.5 !px-5 !text-sm !font-semibold !rounded-md !text-white !bg-teal-600 !hover:bg-teal-700 !focus:outline-none"
                  }
                  buttonLabelClasses=""
                  buttonType={"button"}
                  buttonIcon={
                    isLogin
                      ? "fa-light fa-spinner fa-spin"
                      : "fa-light fa-arrow-right-to-arc"
                  }
                  buttonIconPosition={"left"}
                  buttonLabel={t("signin")}
                  functions={onSubmit}
                  buttonHasLink={false}
                  buttonDisabled={isLogin}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
